import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class EstadosService {
  constructor(private http: HttpClientService) {}

  public get(): Observable<any> {
    return this.http.get("/api/estados").pipe(tap((_) => console.log("EstadosService.get: Ok.")));
  }

  public getSitiables(estado_id: any): Observable<any> {
    return this.http
      .get(`/api/estados/${estado_id}/sitiables`)
      .pipe(tap((_) => console.log("EstadosService.getSitiables: Ok.")));
  }

  public createSitingState(estado_id: number): Observable<any> {
    return this.http
      .post(`/api/estados/${estado_id}/siting_state/init`, {})
      .pipe(tap((_) => console.log("SitingState.post: Ok.")));
  }

  public createSitiables(sitiable): Observable<any> {
    return this.http
      .post("/api/sitiable", sitiable)
      .pipe(tap((_) => console.log("EstadosService.createSitiables: Ok.")));
  }

  public deleteSitiables(estado_id: any, sitiable_state_id: any): Observable<any> {
    let options = {
      params: {
        sitiable_state_id: sitiable_state_id,
      },
    };
    return this.http
      .delete(`/api/sitiable/${estado_id}`, options)
      .pipe(tap((_) => console.log("EstadosService.deleteSitiables: Ok.")));
  }
}
